import React, { useMemo } from 'react';

const DateRangeBar = ({
                          startDate,
                          endDate,
                          title = '',
                          description = '',
                          height = 24,
                          backgroundColor = '#F0F0F0',
                          fillColor = '#BDCCDE'
                      }) => {
    const { percentage, daysElapsed, totalDays, context } = useMemo(() => {
        const start = new Date(startDate);
        const end = new Date(endDate);
        const today = new Date();

        const totalMs = end - start;
        const elapsedMs = today - start;

        const totalDays = Math.ceil(totalMs / (1000 * 60 * 60 * 24));
        const daysElapsed = Math.ceil(elapsedMs / (1000 * 60 * 60 * 24));

        const percentage = Math.min(100, Math.max(0, (daysElapsed / totalDays) * 100));

        // Context for mustache templates
        const context = {
            t1: totalDays - daysElapsed, // days remaining
            t2: daysElapsed,              // days elapsed
            t3: totalDays                 // total days
        };

        return { percentage, daysElapsed, totalDays, context };
    }, [startDate, endDate]);

    // Process description with context values
    const processedDescription = description.replace(/\{([^}]+)\}/g, (match, key) => {
        return context[key] !== undefined ? context[key] : match;
    });

    return (
        <div className="ProgressChartBar">
            {title || processedDescription ? <div className="ProgressChartBar__header">
                {title && (
                    <h2 className="ProgressChartBar__title">
                        {title}
                    </h2>
                )}
                {processedDescription && (
                    <div className="ProgressChartBar__description">
                        {processedDescription}
                    </div>
                )}
            </div> : null}
            <div className="ProgressChartBar__header">
                <span>
                    {startDate}
                </span>
                <span>
                    {endDate}
                </span>
            </div>
            <div className="ProgressChartBar__bar">
                <div className="ProgressChartBar__segment" style={{
                    left: 0,
                    width: `${percentage}%`,
                    backgroundColor: fillColor
                }}/>
            </div>
        </div>
    );
};

export default DateRangeBar;